import { useToasts } from '../hooks/useToasts';
import { Button } from './primitives';
import { Icon } from './Icon';

/** Región de notificaciones. `aria-live` para que se anuncien sin robar el foco. */
export function ToastViewport(): JSX.Element {
  const { toasts, dismiss } = useToasts();

  return (
    <div className="toasts" role="region" aria-label="Notificaciones">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={`toast toast--${toast.kind}`}
          role={toast.kind === 'error' ? 'alert' : 'status'}
          aria-live={toast.kind === 'error' ? 'assertive' : 'polite'}
        >
          <div style={{ flex: '1 1 auto' }}>
            <p className="toast__title">{toast.title}</p>
            {toast.message !== undefined && <p className="toast__msg">{toast.message}</p>}
          </div>
          <Button variant="icon" onClick={() => dismiss(toast.id)} aria-label="Cerrar notificación">
            <Icon name="close" size={14} />
          </Button>
        </div>
      ))}
    </div>
  );
}
